import { render, staticRenderFns } from "./PDTDetail.vue?vue&type=template&id=ff8b7076&scoped=true&"
import script from "./PDTDetail.vue?vue&type=script&lang=ts&"
export * from "./PDTDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PDTDetail.vue?vue&type=style&index=0&id=ff8b7076&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8b7076",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCol,VFadeTransition,VIcon,VRow,VSnackbar,VSubheader,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff8b7076')) {
      api.createRecord('ff8b7076', component.options)
    } else {
      api.reload('ff8b7076', component.options)
    }
    module.hot.accept("./PDTDetail.vue?vue&type=template&id=ff8b7076&scoped=true&", function () {
      api.rerender('ff8b7076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/access-permissions/views/PDTDetail.vue"
export default component.exports